import { render, staticRenderFns } from "./AddNewImage.vue?vue&type=template&id=003366ff&scoped=true&"
import script from "./AddNewImage.vue?vue&type=script&lang=js&"
export * from "./AddNewImage.vue?vue&type=script&lang=js&"
import style0 from "./AddNewImage.vue?vue&type=style&index=0&id=003366ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003366ff",
  null
  
)

export default component.exports